import { R } from 'core/helpers'

const pascalCaseify = (str) => {
  if (!str || !R.isString(str)) return ''
  return str.slice(0, 1).toUpperCase() + str.slice(1)
}

const humanizeSnakeString = (str) =>
  str
    .replace(/_/g, ' ') // underscores -> spaces
    .replace(/\b\w/g, (word) => word.toUpperCase()) // capitalize words
    .trim()

const humanizeCamelString = (str) =>
  pascalCaseify(str)
    .replace(/([A-Z]+)/g, '$1')
    .replace(/([A-Z][a-z])/g, ' $1')
    .trim()

const acronyms = ['id', 'ui', 'gui', 'saml', 'sso', 'scra']

const humanizeKey = (key = '') => {
  const lowerKey = key.toLowerCase()
  if (R.isIncludedIn(lowerKey, acronyms)) return lowerKey.toUpperCase()

  const str = key.includes('_') ? humanizeSnakeString(key) : humanizeCamelString(key)

  // Handle acronyms in the middle of strings (e.g., "zendesk Sso" -> "Zendesk SSO", "Monitoring Scra" -> "Monitoring SCRA")
  let result = str
  acronyms.forEach((acronym) => {
    // Match acronym as whole word (case insensitive) and replace with uppercase
    const regex = new RegExp(`\\b${acronym}\\b`, 'gi')
    result = result.replace(regex, acronym.toUpperCase())
  })

  return result.endsWith(' Id') ? result.slice(0, -3) + ' ID' : result
}

export default humanizeKey
